import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.scss']
})
export class LocationDetailComponent extends BaseDetail implements OnInit {

  public location: LocationModel = null;
  public backRoute = ['/locations'];

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('locations', params.id).subscribe({
          next: (result: any) => {
            this.location = new LocationModel().deserialize(result.data);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
